/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import styled from "styled-components";
import { datadogRum } from "@datadog/browser-rum";

import * as API from "../../../../api/billing";
import {
  StyledButton,
  StyledButtonContainer,
  StyledLabel,
  StyledInput,
  StyledModalBody,
  StyledModalContents,
} from "../lib/styles";
import { UpdatePONumbersModalBodyProps } from "../lib/types";
import { redesignTheme } from "../../../theme/theme";

const StyledInputLessMargin = styled(StyledInput)`
  &&& {
    margin-bottom: ${redesignTheme.spacing[1.5]};
  }
`;

const StyledHelperText = styled.p`
  font-family: ${redesignTheme.fontFamily.interface};
  color: ${redesignTheme.color.gray600};
  font-size: ${redesignTheme.fontSize[50]};
  margin-bottom: ${redesignTheme.spacing[1.5]};
`;

const UpdatePONumbersModalBody = ({
  closeModal,
  companyId,
  fetchData,
  rewardsPONumber,
  subscriptionPONumber,
  updateToastMessage,
}: UpdatePONumbersModalBodyProps): React.ReactElement => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [rewards, setRewards] = React.useState<string>(rewardsPONumber);
  const [subscription, setSubscription] = React.useState<string>(
    subscriptionPONumber
  );

  const handleUpdatePONumbers = async (): Promise<void> => {
    try {
      setLoading(true);
      const data = {
        rewards_po_number: rewards,
        subscription_po_number: subscription,
      };

      await API.updatePurchaseOrderNumbers(companyId, data);
      setLoading(false);

      updateToastMessage({
        isOpen: true,
        message: i18n.translate(
          "admin_pages.settings.billing.po_numbers.confirmation"
        ),
        type: "success",
      });
      fetchData();
      closeModal();
    } catch (error) {
      datadogRum.addError(error);
      setLoading(false);
      updateToastMessage({
        isOpen: true,
        message: i18n.translate(
          "admin_pages.settings.billing.po_numbers.error"
        ),
        type: "error",
      });
    }
  };

  return (
    <StyledModalBody data-testid="update-po-numbers-modal-body">
      <StyledModalContents>
        <StyledLabel htmlFor="subscription">
          {i18n.translate(
            "admin_pages.settings.billing.po_numbers.subscription"
          )}
        </StyledLabel>
        <StyledInputLessMargin
          data-testid="subscription-input"
          id="subscription"
          name="subscription"
          onChange={(event): void => {
            return setSubscription(event.target.value);
          }}
          placeholder={i18n.translate(
            "admin_pages.settings.billing.po_numbers.po_number"
          )}
          value={subscription}
        />
        <StyledHelperText>
          {i18n.translate(
            "admin_pages.settings.billing.po_numbers.subscription_helper"
          )}
        </StyledHelperText>
        <StyledLabel style={{ marginTop: "12px" }} htmlFor="rewards">
          {i18n.translate("admin_pages.settings.billing.po_numbers.reward")}
        </StyledLabel>
        <StyledInputLessMargin
          data-testid="rewards-input"
          id="rewards"
          name="rewards"
          onChange={(event): void => {
            return setRewards(event.target.value);
          }}
          placeholder={i18n.translate(
            "admin_pages.settings.billing.po_numbers.po_number"
          )}
          value={rewards}
        />
        <StyledHelperText>
          {i18n.translate(
            "admin_pages.settings.billing.po_numbers.reward_helper"
          )}
        </StyledHelperText>
      </StyledModalContents>

      <StyledButtonContainer>
        <StyledButton
          onClick={closeModal}
          size="small"
          testId="cancel-button"
          variant="secondary"
        >
          {i18n.translate("forms.cancel")}
        </StyledButton>
        <StyledButton
          disabled={loading}
          onClick={handleUpdatePONumbers}
          size="small"
          testId="update-button"
          variant="primary"
        >
          {i18n.translate("forms.update")}
        </StyledButton>
      </StyledButtonContainer>
    </StyledModalBody>
  );
};

export default UpdatePONumbersModalBody;
